import { useEffect } from "react";

const BASE = "https://uyizhan.cn";

interface SeoOptions {
  title: string;
  description: string;
  path?: string;
  type?: string;
  ld?: Record<string, unknown> | null;
}

function setMeta(selector: string, attr: string, value: string) {
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    const key = attr === "property" ? "property" : "name";
    el.setAttribute(key, selector.split('"')[1] ?? "og:title");
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function useSeo({ title, description, path = "/", type = "website", ld = null }: SeoOptions) {
  useEffect(() => {
    const fullTitle = title.includes("瓜田日报") ? title : `${title} - 瓜田日报`;
    document.title = fullTitle;
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    const url = BASE + path;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:type"]', "content", type);

    if (ld) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-ld-json";
      script.textContent = JSON.stringify(ld);
      document.head.appendChild(script);
      return () => {
        document.getElementById("page-ld-json")?.remove();
      };
    }
    document.getElementById("page-ld-json")?.remove();
    return undefined;
  }, [title, description, path, type, ld]);
}